export default __webpack_public_path__ + "static/media/flags.be08e68d.png";